import { createSlice } from "@reduxjs/toolkit";

export const thisUserSlice = createSlice({
  name: "user",
  initialState: { user: null },
  reducers: {
    set: (state, action) => {
      state.user = action.payload;
    },
  },
});

export const thisUserActions = thisUserSlice.actions;
export default thisUserSlice;
